import { render } from "./ServicePartsSection.vue?vue&type=template&id=1241c078&scoped=true"
import script from "./ServicePartsSection.vue?vue&type=script&lang=js"
export * from "./ServicePartsSection.vue?vue&type=script&lang=js"

import "./ServicePartsSection.vue?vue&type=style&index=0&id=1241c078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1241c078"]])

export default __exports__